<div class="fixed inset-0 z-[70] flex items-center justify-center p-4">

    <!-- Backdrop overlay -->
    <div class="absolute inset-0 bg-slate-900/40 backdrop-blur-md transition-opacity duration-300 animate-fade-in"
        (click)="closeAddVehicleModal()">
    </div>

    <!-- Modal Container -->
    <div
        class="relative bg-white/95 dark:bg-slate-900/95 w-full max-w-xl rounded-[32px] shadow-[0_20px_60px_-15px_rgba(0,0,0,0.3)] border border-white/50 dark:border-slate-800/50 flex flex-col backdrop-blur-xl animate-scale-up max-h-[90vh]">

        <!-- Modal Header -->
        <div
            class="px-6 py-6 border-b border-slate-200/50 dark:border-slate-800/50 flex justify-between items-center bg-transparent gap-4 relative z-10">
            <div class="flex items-center gap-4">
                <div
                    class="w-12 h-12 rounded-2xl bg-gradient-to-tr from-amber-400/70 to-amber-400/50 dark:from-amber-400 dark:to-amber-400 flex items-center justify-center text-white shadow-lg shadow-gray-200 dark:shadow-amber-400/20">
                    <span class="material-icons-outlined text-2xl">directions_car</span>
                </div>
                <div>
                    <h3 class="text-xl font-black text-slate-800 dark:text-white tracking-tight uppercase">
                        {{ licenseOld ? 'แก้ไขทะเบียนรถ' : 'เพิ่มทะเบียนรถใหม่' }}
                    </h3>
                    <p class="text-xs text-gray-500 dark:text-slate-400 mt-0.5">
                        {{ licenseOld ? 'แก้ไขข้อมูลรายละเอียดรถของสมาชิก' : 'กรอกข้อมูลรถของสมาชิกเพื่อบันทึกเข้าระบบ'
                        }}
                    </p>
                </div>
            </div>
            <button (click)="closeAddVehicleModal()"
                class="w-10 h-10 flex items-center justify-center rounded-full bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-500 dark:text-slate-400 transition-colors shadow-sm">
                <span class="material-icons-outlined text-xl">close</span>
            </button>
        </div>

        <!-- Modal Body -->
        <div class="p-6 md:p-8 space-y-6  custom-scrollbar bg-slate-50/30 dark:bg-slate-900/30 relative">

            <!-- Information Card -->
            <div
                class="bg-white dark:bg-slate-800/50 rounded-2xl p-6 border border-slate-200/60 dark:border-slate-800 shadow-sm space-y-6">

                <!-- Plate Number Input -->
                <div class="space-y-2">
                    <div class="flex justify-between items-center">
                        <label
                            class="text-[13px] font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider">เลขทะเบียน
                            <span class="text-rose-500">*</span></label>
                        <span *ngIf="eventForm == 'edit'"
                            class="text-[11px] font-bold bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400 px-2 py-0.5 rounded-lg border border-amber-100 dark:border-amber-800">
                            ก่อนหน้า: {{ licenseOld?.plateNumber }}
                        </span>
                    </div>
                    <div class="relative group">
                        <div
                            class="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 group-focus-within:text-amber-500 transition-colors">
                            <span class="material-icons-outlined text-[20px]">badge</span>
                        </div>
                        <input type="text" [(ngModel)]="plateNumber" (ngModelChange)="onPlateNumberChange($event)"
                            maxlength="7" placeholder="เช่น 1กก1234 (ไม่ต้องเว้นวรรค)"
                            class="w-full h-12 pl-12 pr-4 rounded-xl text-sm bg-white dark:bg-slate-800 border-2 transition-all outline-none"
                            [ngClass]="errors.plateNumber ? 'border-rose-400 ring-4 ring-rose-400/10' : 'border-slate-100 dark:border-slate-700 focus:border-amber-400 dark:focus:border-amber-500 focus:ring-4 focus:ring-amber-400/10'">
                    </div>
                    <div class="flex justify-between items-center px-1">
                        <p *ngIf="errors.plateNumber" class="text-xs text-rose-500 font-bold animate-pulse">{{
                            errors.plateNumber }}</p>
                        <p class="text-[10px] text-slate-400 font-medium ml-auto">* ระบบจะลบช่องว่างให้อัตโนมัติ</p>
                    </div>
                </div>

                <!-- Custom Dropdown Grid -->
                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">

                    <!-- Province Custom Dropdown -->
                    <div class="space-y-2 relative">
                        <label
                            class="text-[13px] font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider">จังหวัด
                            <span class="text-rose-500">*</span></label>
                        <div class="relative">
                            <button (click)="toggleProvinceDropdown()"
                                class="w-full h-12 px-4 rounded-xl text-sm bg-white dark:bg-slate-800 border-2 flex items-center justify-between transition-all hover:bg-slate-50 dark:hover:bg-slate-700/50"
                                [ngClass]="errors.provinceId ? 'border-rose-400 ring-4 ring-rose-400/10' : 'border-slate-100 dark:border-slate-700 focus:border-amber-400'">
                                <div class="flex items-center gap-3">
                                    <span class="material-icons-outlined text-slate-400 text-[20px]">location_on</span>
                                    <span
                                        [ngClass]="provinceId ? 'text-slate-800 dark:text-slate-100 font-bold' : 'text-slate-400'">{{
                                        selectedProvinceName }}</span>
                                </div>
                                <span class="material-icons-outlined text-slate-400 transition-transform duration-200"
                                    [style.transform]="isProvinceDropdownOpen ? 'rotate(180deg)' : 'rotate(0)'">expand_more</span>
                            </button>

                            <!-- Dropdown Menu -->
                            <div *ngIf="isProvinceDropdownOpen"
                                class="absolute left-0 right-0 mt-2 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-2xl shadow-2xl z-[80] overflow-hidden animate-fade-in-up origin-top">
                                <div class="p-2 border-b border-slate-100 dark:border-slate-700">
                                    <div class="relative">
                                        <span
                                            class="material-icons-outlined absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-lg">search</span>
                                        <input type="text" [(ngModel)]="searchTermProvince"
                                            placeholder="ค้นหาจังหวัด..."
                                            class="w-full h-10 pl-10 pr-4 bg-slate-50 dark:bg-slate-900 rounded-lg text-xs outline-none focus:ring-2 focus:ring-amber-500/20 transition-all font-medium">
                                    </div>
                                </div>
                                <div class="max-h-60 overflow-y-auto custom-scrollbar">
                                    <button *ngFor="let province of filteredProvinces"
                                        (click)="selectProvince(province)"
                                        class="w-full px-4 py-3 text-left text-sm hover:bg-amber-50 dark:hover:bg-amber-500/10 flex items-center justify-between group transition-colors">
                                        <span
                                            [ngClass]="provinceId === province.id ? 'text-amber-600 dark:text-amber-400 font-black' : 'text-slate-600 dark:text-slate-300 font-medium'">{{
                                            province.name }}</span>
                                        <span *ngIf="provinceId === province.id"
                                            class="material-icons-outlined text-amber-500 text-lg">check_circle</span>
                                    </button>
                                    <div *ngIf="filteredProvinces.length === 0"
                                        class="p-8 text-center text-slate-400 text-xs font-bold">ไม่พบข้อมูลจังหวัด
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p *ngIf="errors.provinceId" class="text-xs text-rose-500 font-bold px-1">{{ errors.provinceId
                            }}</p>
                    </div>

                    <!-- Vehicle Type Custom Dropdown -->
                    <div class="space-y-2 relative">
                        <label
                            class="text-[13px] font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider">ประเภทรถ
                            <span class="text-rose-500">*</span></label>
                        <div class="relative">
                            <button (click)="toggleVehicleTypeDropdown()"
                                class="w-full h-12 px-4 rounded-xl text-sm bg-white dark:bg-slate-800 border-2 flex items-center justify-between transition-all hover:bg-slate-50 dark:hover:bg-slate-700/50"
                                [ngClass]="errors.vehicleTypeId ? 'border-rose-400 ring-4 ring-rose-400/10' : 'border-slate-100 dark:border-slate-700 focus:border-amber-400'">
                                <div class="flex items-center gap-3">
                                    <span class="material-icons-outlined text-slate-400 text-[20px]">airport_shuttle</span>
                                    <span
                                        [ngClass]="vehicleTypeId ? 'text-slate-800 dark:text-slate-100 font-bold' : 'text-slate-400'">{{
                                        selectedVehicleTypeName }}</span>
                                </div>
                                <span class="material-icons-outlined text-slate-400 transition-transform duration-200"
                                    [style.transform]="isVehicleTypeDropdownOpen ? 'rotate(180deg)' : 'rotate(0)'">expand_more</span>
                            </button>

                            <!-- Dropdown Menu -->
                            <div *ngIf="isVehicleTypeDropdownOpen"
                                class="absolute left-0 right-0 mt-2 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-2xl shadow-2xl z-[80] overflow-hidden animate-fade-in-up origin-top">
                                <div class="p-2 border-b border-slate-100 dark:border-slate-700">
                                    <div class="relative">
                                        <span
                                            class="material-icons-outlined absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-lg">search</span>
                                        <input type="text" [(ngModel)]="searchTermVehicleType"
                                            placeholder="ค้นหาประเภท..."
                                            class="w-full h-10 pl-10 pr-4 bg-slate-50 dark:bg-slate-900 rounded-lg text-xs outline-none focus:ring-2 focus:ring-amber-500/20 transition-all font-medium">
                                    </div>
                                </div>
                                <div class="max-h-60 overflow-y-auto custom-scrollbar">
                                    <button *ngFor="let type of filteredVehicleTypes" (click)="selectVehicleType(type)"
                                        class="w-full px-4 py-3 text-left text-sm hover:bg-amber-50 dark:hover:bg-amber-500/10 flex items-center justify-between group transition-colors">
                                        <span
                                            [ngClass]="vehicleTypeId === type.id ? 'text-amber-600 dark:text-amber-400 font-black' : 'text-slate-600 dark:text-slate-300 font-medium'">{{
                                            type.name }}</span>
                                        <span *ngIf="vehicleTypeId === type.id"
                                            class="material-icons-outlined text-amber-500 text-lg">check_circle</span>
                                    </button>
                                    <div *ngIf="filteredVehicleTypes.length === 0"
                                        class="p-8 text-center text-slate-400 text-xs font-bold">ไม่พบข้อมูลประเภทรถ
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p *ngIf="errors.vehicleTypeId" class="text-xs text-rose-500 font-bold px-1">{{
                            errors.vehicleTypeId }}</p>
                    </div>

                </div>
            </div>

            <!-- Hint Section -->
            <div
                class="flex items-center gap-3 px-5 py-3 bg-amber-50/50 dark:bg-amber-500/10 rounded-xl border border-amber-100/50 dark:border-amber-500/20">
                <span class="material-icons-outlined text-amber-500 text-xl">info</span>
                <p
                    class="text-[11px] text-amber-700 dark:text-amber-400 font-bold uppercase tracking-wider leading-relaxed">
                    กรุณาตรวจสอบข้อมูลเลขทะเบียนและจังหวัดให้ถูกต้องก่อนการบันทึก เพื่อการทำงานของระบบที่แม่นยำ
                </p>
            </div>

        </div>

        <!-- Modal Footer -->
        <div
            class="px-6 py-6 border-t border-slate-200/50 dark:border-slate-800/50 dark:bg-slate-900/50 flex flex-col-reverse sm:flex-row justify-end gap-3 sticky bottom-0">
            <button (click)="closeAddVehicleModal()"
                class="w-full sm:w-auto px-6 py-3 text-sm font-bold text-slate-600 dark:text-slate-300 hover:bg-white dark:hover:bg-slate-800 rounded-2xl transition-all shadow-sm border border-slate-200 dark:border-slate-700 cursor-pointer">
                ยกเลิก
            </button>
            <button (click)="confirmAddVehicle()"
                class="w-full sm:w-auto px-10 py-3 text-sm font-bold text-white bg-gradient-to-r from-amber-500/80 to-yellow-500/70 dark:from-amber-500 dark:to-yellow-500 hover:brightness-110 rounded-2xl shadow-[0_10px_25px_-8px_rgba(245,158,11,0.5)] hover:shadow-[0_15px_30px_-8px_rgba(245,158,11,0.6)] hover:-translate-y-0.5 active:scale-95 transition-all flex items-center justify-center gap-2 group cursor-pointer">
                <span class="material-icons-outlined text-[20px] group-hover:scale-110 transition-transform">save</span>
                บันทึกข้อมูลรถ
            </button>
        </div>
    </div>
</div>

<app-pss-loading *ngIf="isLoading"></app-pss-loading>